import * as React from 'react';
import type { CampusApplicationEvent } from '~/Features/CampusApplication/Events/CampusApplicationEvents';
import {
    AddingExistingItemAttempt,
    CampusApplicationItemAdded,
} from '~/Features/CampusApplication/Events/CampusApplicationEvents';
import { MessageBroker } from '~/Features/Messaging/MessageBroker';
import type { EventHandler } from '~/Features/Messaging/types';
import { Link } from '~/Partials/Link/Link';
import { SvgIcon } from '~/Partials/SvgIcon/SvgIcon';
import styles from './NotificationBanner.module.css';
import { NotificationBannerBase } from './NotificationBannerBase';
import type { NotificationBannerViewModel } from './NotificationBannerViewModel.csharp';

interface NotificationBannerState {
    isOpen: boolean;
    eventId: string;
}

export class NotificationBanner
    extends React.Component<NotificationBannerViewModel, NotificationBannerState>
    implements EventHandler<CampusApplicationEvent>
{
    private timeoutId: ReturnType<typeof setTimeout> | null = null;

    constructor(props: NotificationBannerViewModel) {
        super(props);
        this.state = {
            isOpen: false,
            eventId: '',
        };
    }

    componentDidMount(): void {
        MessageBroker.subscribe(this, CampusApplicationItemAdded.id);
        MessageBroker.subscribe(this, AddingExistingItemAttempt.id);
    }

    componentWillUnmount(): void {
        MessageBroker.unsubscribe(this, CampusApplicationItemAdded.id);
        MessageBroker.unsubscribe(this, AddingExistingItemAttempt.id);
        this.clearTimeout();
    }

    public handle(event: CampusApplicationEvent): void {
        this.setState({
            isOpen: true,
            eventId: event.id,
        });

        this.setClosingOfNotificationBanner();
    }

    public render() {
        const {
            studyName,
            campusApplicationFormUrl,
            alreadyAddedToTranslation,
            wasAddedToTranslation,
            yourApplicationTranslation,
        } = this.props;
        const { eventId, isOpen } = this.state;
        const messageMiddlePart =
            eventId === AddingExistingItemAttempt.id ? alreadyAddedToTranslation : wasAddedToTranslation;

        return (
            <NotificationBannerBase isOpen={isOpen}>
                <div>
                    <SvgIcon className={styles.Icon} iconName="bell" />
                    {studyName} {messageMiddlePart}
                    <Link
                        className={styles.ApplicationLink}
                        href={campusApplicationFormUrl}
                        label={`${yourApplicationTranslation}.`}
                    />
                </div>
            </NotificationBannerBase>
        );
    }

    private setClosingOfNotificationBanner(): void {
        this.clearTimeout();
        this.timeoutId = setTimeout(() => {
            this.setState({ isOpen: false });
        }, 10000);
    }

    private clearTimeout(): void {
        if (this.timeoutId) {
            clearTimeout(this.timeoutId);
        }
    }
}

export default NotificationBanner;
